import { 
  Divider, Grid, Paper, Typography, Box, Button, CircularProgress, Snackbar 
} from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert"; // para mostrar estilos de error/success
import LoaderBar from "components/LoaderBar/LoaderBar";
import PageTitle from "components/PageTitle/PageTitle";
import InvertedTable from "components/Table/InvertedTable";
import { useEffect, useState } from "react";
import { dbGet, dbPostWithFormData } from "utils/DBFetchers";

import useStyles from "./styles";

export default function PharmacyBalancePage() {
  const classes = useStyles();
  const [balance, setBalance] = useState(0);
  const [pharmacyRut, setPharmacyRut] = useState("");
  const [downloading, setDownloading] = useState(false);

  // estado del snackbar
  const [snackbar, setSnackbar] = useState({
    open: false,
    severity: "info", // "success" | "error" | "warning" | "info"
    message: "",
  });

  useEffect(() => {
    dbGet("wallet/internal/balances/pharmacy_supervisor")
      .then((data) => {
        setBalance(data.balance);
        setPharmacyRut(data.pharmacy_rut);
      })
      .catch(() => {
        setBalance(0);
        setPharmacyRut("");
      });
  }, []);

  const handleDownload = async () => {
    if (!pharmacyRut) {
      setSnackbar({
        open: true,
        severity: "error",
        message: "No se pudo determinar el RUT de la farmacia.",
      });
      return;
    }

    setDownloading(true);
    try {
      const formData = new FormData();
      formData.append("pharmacy_rut", pharmacyRut);

      const postData = await dbPostWithFormData(
        "cli/export_pharmacy_balance_composition",
        formData
      );
      if (!postData?.output_files) {
        throw new Error("Respuesta inválida del servidor");
      }

      const entries = Object.entries(postData.output_files || {});
      const [filename, url] = entries[0] || [];

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);

      setSnackbar({
        open: true,
        severity: "success",
        message: "Archivo generado con éxito",
      });
    } catch (e) {
      setSnackbar({
        open: true,
        severity: "error",
        message: "Error al generar el archivo. Intente nuevamente.",
      });
    } finally {
      setDownloading(false);
    }
  };

  return (
    <Grid>
      <PageTitle title="Billetera virtual - Consultar Saldo" />

      <Paper elevation={3} className={classes.paperContainer}>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          minHeight={200}
          p={3}
        >
          <Typography style={{ fontWeight: 600, marginBottom: 12 }}>
            Farmacia (RUT): {pharmacyRut || "-"}
          </Typography>

          <Typography style={{ fontWeight: 700, marginBottom: 8 }}>
            Saldo actual
          </Typography>
          <Box
            component={Paper}
            elevation={2}
            px={4}
            py={2}
            style={{
              borderRadius: 12,
              backgroundColor: "#f9f9f9",
              minWidth: 200,
              textAlign: "center",
            }}
          >
            <Typography variant="h5" style={{ fontWeight: 700, color: "#2e7d32" }}>
              ${balance.toLocaleString("es-AR")}
            </Typography>
          </Box>
        </Box>

        <Box display="flex" justifyContent="flex-end" p={2}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleDownload}
            disabled={downloading}
            startIcon={downloading ? <CircularProgress size={18} /> : null}
          >
            {downloading ? "Generando..." : "Descargar composición de Saldo"}
          </Button>
        </Box>
      </Paper>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          elevation={6}
          variant="filled"
        >
          {snackbar.message}
        </MuiAlert>
      </Snackbar>
    </Grid>
  );
}
